import * as propertyTypes from "../property_types.js"


export class UiKendoCombobox extends propertyTypes.AppBaseComponentProps {

    private listWidthMetadata = new propertyTypes.CheckBoxProperty("listWidth", "List width");
    public listWidth: string;

    private metadataAll: propertyTypes.BaseProperty[];
    constructor() {
        super();
        const baseMetaData = super.getMetadata();
        this.metadataAll = baseMetaData.concat([this.listWidthMetadata]);
    };

    getMetadata(): propertyTypes.BaseProperty[] {
        return this.metadataAll;
    }
}